<template>
  <div style="display: flex">
    <small class="m-1 mr-3">from</small>
    <b-input-group class="max-width-170">
      <b-form-input
        v-model="fromDate"
        type="text"
        autocomplete="off"
        size="sm"
        disabled
      ></b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="fromDate"
          :max="toDate"
          button-only
          size="sm"
          right
        ></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
    <small class="m-1 mx-3">to</small>
    <b-input-group class="max-width-170">
      <b-form-input
        v-model="toDate"
        type="text"
        autocomplete="off"
        size="sm"
        disabled
      ></b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="toDate"
          :min="fromDate"
          button-only
          size="sm"
          right
        ></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </div>
</template>

<script>
export default {
  props: ['filter'],
  data() {
    const today = this.FormatDate(new Date());

    return {
      fromDate: today,
      toDate: today,
      result: ''
    };
  },
  mounted() {
    this.UpdateData();
  },
  computed: {
    modifiedFromDate() {
      if (this.fromDate) {
        if (this.filter.level.levelDbType === 'DATE1') {
          return (
            this.filter.level.levelId + '.&[' + this.fromDate + 'T00:00:00]'
          );
        } else {
          return this.filter.level.levelId + '.&[' + this.fromDate + ']';
        }
      } else {
        return '';
      }
    },
    modifiedToDate() {
      if (this.toDate) {
        if (this.filter.level.levelDbType === 'DATE1') {
          return this.filter.level.levelId + '.&[' + this.toDate + 'T00:00:00]';
        } else {
          return this.filter.level.levelId + '.&[' + this.toDate + ']';
        }
      } else {
        return '';
      }
    }
  },
  watch: {
    fromDate() {
      this.UpdateData();
    },
    toDate() {
      this.UpdateData();
    }
  },
  methods: {
    FormatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = '0' + month;
      if (day.length < 2) day = '0' + day;

      return [year, month, day].join('-');
    },
    UpdateData() {
      var result = this.modifiedFromDate + ' : ' + this.modifiedToDate;
      this.$emit('input', [result]);
    }
  }
};
</script>

<style lang="scss" scoped>
input:disabled {
  background: none;
}
</style>
